import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { MDBContainer } from "mdb-react-ui-kit";


const GETDATABYID = "/api/shortvideo"

const ShortVideoModal = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if (show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data?.shortvideo
                Setcontent(data)
                console.log(response.data)
            } else {

                Setcontent([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Short Video Details -{content?.videohindititle} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {
                    content?.status === "published" ? <strong className="text-capitalize text-green">{content?.status}  </strong> : <strong className="text-capitalize text-red">{content?.status} on {content?.scheduledate} </strong>  
                }
                <Table bordered striped hover>
                    {
                        content?.videofile?.map((item, i) => (
                            <video src={item?.location} className="w-100" controls key={i} ></video>
                        ))
                    }
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default ShortVideoModal;